import { inject } from 'dependable-react';
import TagManager from 'react-gtm-module';
import { APP_DATA_TOKEN } from '../services/InjectTokens';
import { GTM_ID_DEVELOPMENT } from '../consts/gtm';
interface IStep {
  item_name?: string;
  item_id?: string | number;
  step?: string;
}
interface IEcommerce {
  item_id?: string | number;
  item_name?: string;
  item_category?: string;
  price?: string | number;
}

interface IItem {
  items: Array<IStep> | Array<IEcommerce>;
}

interface IDataLayer {
  event: string;
  korak?: IItem;
  ecommerce?: IItem;
}

function translateKeyValue(value: string) {
  let transformedValue = value.toLowerCase();
  transformedValue = transformedValue.replace(/\s/g, '_');
  return transformedValue;
}

export const pushGtmData = (gtmObject: IDataLayer) => {
  if (
    process.env.NODE_ENV === 'production' ||
    (process.env.NODE_ENV === 'development' && GTM_ID_DEVELOPMENT)
  ) {
    const appState = inject(APP_DATA_TOKEN);

    if (gtmObject && Object.keys(gtmObject).length !== 0 && gtmObject.constructor === Object) {
      if (gtmObject.korak && gtmObject.korak.items && gtmObject.korak.items.length) {
        //@ts-ignore
        gtmObject.korak.items = gtmObject.korak.items.map(({ step }) => {
          return {
            item_name: appState.translations[appState.currentLanguage].title,
            item_id: appState.bookId,
            step: step && translateKeyValue(step),
          };
        });
      }
      const dataLayer = {
        ...gtmObject,
      };

      TagManager.dataLayer({ dataLayer });
    }
  }
};
